<script setup>
    /**
     * Vue Scripts
     */
    import {computed} from "vue";
    import {trialStore} from "@pinia/trial-store";
    import {locationsAndMarkers} from "@util/map";
    import {dataLayer} from "@util/util";

    /**
     * Vue Components
     * @link https://github.com/wobsoriano/vue-use-places-autocomplete
     */
    import InputAutocomplete from "@component/InputAutocomplete/InputAutocomplete.vue";

    const store = trialStore()

    const {apiKey, apiUrl, pageName} = TRIAL;
    const locationName = computed(() => store.locationName)
    const query = computed(() => store.query)

    const {
        label,
        placeholder,
        searchText,
    } = LABELS?.filterLabels?.zipCode;

    //region Flex Trial Colors
    let searchColorClass = [];

    if (typeof TRIAL_COLORS !== 'undefined') {
        searchColorClass.push(TRIAL_COLORS.searchColor);
    }

    /**
     * Updates the state with the name selected and the coords for it
     * @param {String} name Name of the location searched
     * @param {Object} coords Latitude and Longitude of the location selected
     */
    const getLocation = ({name, coords}) => {
        store.$patch({
            loading: true,
            locationName: name || '',
            query: {
                ...store.query,
                ...coords,
            }
        });

        /**
         * Send the location searched to GA
         */
        dataLayer(
            {
                event: 'locationSearchBox',
                locationSearched: name,
                trialName: pageName,
                element: document.getElementById('google-location-search')
            }
        )

        /**
         * Fetch and reorder the listing and markers for the map
         */
        locationsAndMarkers(apiUrl, query.value)
            .then(({locations, markers}) => (locations && markers) && store.$patch({locations, markers}))
            .finally(() => store.$patch({loading: false}))
    }
</script>

<template>
    <div
        class="zip-search"
        :class="searchColorClass.length && searchColorClass.join(' ')"
    >
        <InputAutocomplete
            id="google-location-search"

            :api-key="apiKey"
            :label="label"
            :placeholder="placeholder"
            select-on-enter
            :value="locationName"

            @getLatLng="getLocation"
        />

        <button v-html="searchText" />
    </div>
</template>

<script>
    export default {
        name: "Search Bar"
    }
</script>

<style scoped lang="scss">

</style>
